import React from 'react';

import LoadingOverlay from 'components/LoadingOverlay';
import { Step } from 'components/SteppedModal';
import { LinkedinPostModalSteps } from './types';

const useAuthenticationProgressStep = (): Step<LinkedinPostModalSteps> => {
  return {
    id: 'authentication-in-progress',
    title: 'Authenticating with LinkedIn',
    fluidFooterButtons: true,
    hideFooter: true,
    component: <LoadingOverlay small />,
  };
};

export default useAuthenticationProgressStep;
